<script>

    import { toast } from 'bulma-toast'
    import { creditStore, creditsStore, modalStore } from '../stores'

    import CreditsService from '../$services/credits.service'

    import InputText from '../$components/input.text.svelte'
    import Select from '../$components/select.svelte'
    import Form from '../$components/form.svelte'

    import ButtonSave from '../$components/button.save.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    let data = {
        status: $creditStore.status,
        reference: $creditStore.reference,
    }

    let loading = false

    async function updateCredit() {

        loading = true
        const resp = await CreditsService.updateCredit($creditStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        creditsStore.replace(resp.data)
        creditStore.set(resp.data)

        toast({message: 'Credito actualizado', type: 'is-success'})
        modalStore.set('credit_modal')
    }

</script>

<Form on:submit={updateCredit} {loading}>

    <Select bind:value={data.status}
        label="Estatus"
        options={[
            {value: 'pending', text: 'Pendiente'},
            {value: 'paid', text: 'Pagado'},
            {value: 'free', text: 'Gratis'},
        ]}
    />

    <InputText bind:value={data.reference} label="Referencia" placeholder="Referencia" />

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <ButtonModal modalId="credit_modal" text="Cancelar" icon="ban" />
        <ButtonSave icon="edit" text="Actualizar" />
    </div>
</Form>